module.exports = __webpack_public_path__ + "img/20171225_164412-min.2c5e0f23.jpg";